export class OnboardingSliderMenu {
	private element: HTMLElement | null = null;
	private lineUp: HTMLElement | null = null;
	private lineDown: HTMLElement | null = null;
	private current: HTMLElement | null = null;
	private items: any | null = null;
	private currentIndex: number = 0;
	private itemId: string = '';

	constructor(selector: string, itemId: string) {
		const element = this.element = document.querySelector(selector);

		if (element) {
			const list = element.querySelector('[data-slider-menu="list"]');

			if (list) {
				this.items = [].slice.call(list.children);
			}

			this.lineUp = element.querySelector('[data-slider-menu="line-up"]');

			this.lineDown = element.querySelector('[data-slider-menu="line-down"]');

			if (itemId) {
				this.setCurrent(itemId);
			}
		}
	}

	setPassed() {
		const currentIndex = this.currentIndex;
		const items = this.items;

		if (items && items.length > 0) {
			for (let i = 0, n = items.length; i < n; i++) {
				const item = items[i];

				if (currentIndex > i) {
					item.classList.add('passed');

					continue;
				}

				item.classList.remove('passed');
			}
		}
	}

	getCurrentIndex() {
		const itemId = this.itemId;
		const index = this.items ? this.items.findIndex((a: any) => a.id === itemId) : 0;

		if (index < 0) {
			throw new Error('Item ID is not defined!');
		}

		return index;
	}

	updateLineUpHeight() {
		const current = this.current;

		const lineUp = this.lineUp;

		if (lineUp && current) {
			lineUp.style.height = this.isLast() ? '100%' : (current.offsetTop + (current.offsetHeight / 2)) + 'px';
		}
	}

	isLast() {
		const items = this.items;

		return this.current === items[items.length - 1];
	}

	removeCurrent() {
		const lastCurrent = this.getCurrent();

		if (!lastCurrent) {
			return;
		}

		lastCurrent.classList.remove('current');
	}

	setCurrent(itemId: string) {
		this.removeCurrent();

		this.itemId = itemId;

		this.currentIndex = this.getCurrentIndex();

		const current = this.current = this.getCurrent();

		if (current) {
			current.classList.add('current');
		}

		this.setPassed();

		this.updateLineUpHeight();
	}

	getCurrent() {
		return this.items ? this.items[this.currentIndex] : null;
	}
}
